import colors from './colors';
import safelist from './safelist';
import spacings from './spacings';

export default { colors, safelist, spacings };
